import { I18n } from "@assets/strings";
import React from "react";
import { allContentLevels, ContentLevel } from "@domain/lms/contentLevel";
import { Selecter } from "@ui/components/inputs/selecter";

interface LevelEditorProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "value" | "onChange"> {
	value?: ContentLevel;
	onChange: (value?: ContentLevel) => void;
	placeholder?: string;
	optional?: boolean;
	isQuizz?: boolean;
}

export const LevelEditor: React.FC<LevelEditorProps> = ({
	value,
	onChange,
	placeholder,
	optional,
	isQuizz,
	...htmlProps
}) => {
	const options = allContentLevels.map((level) => ({
		value: level,
		label: isQuizz ? I18n.t(`quiz.level.${level}`) : I18n.t(`level.${level}`),
	}));

	return (
		<Selecter
			{...htmlProps}
			placeholder={placeholder}
			value={value}
			onChange={(level) => {
				onChange(level === "NONE" ? undefined : (level as ContentLevel));
			}}
			options={
				optional
					? [
							{
								value: "NONE",
								label: I18n.t("level.none"),
							},
							...options,
						]
					: options
			}
		/>
	);
};
